<template>
  <div class="page">
    <div class="page-title">新增職員</div>
    <div class="form-box">
    <staffFrom ref="form" :form="form"></staffFrom>
    <div class="page-button">
      <el-button type="info" @click="onSubmit">提交</el-button>
      <el-button type="success" @click="onBackUser">取消</el-button>
    </div>
    </div>
  </div>
</template>

<script>
import {addUser} from '@/api/users'
import staffFrom from "./components/staffFrom.vue";
export default {
  components: { staffFrom },
  data() {
    return {
      form: {
        userNo: null,
        name: null,
        gender: null,
        email: null,
        password: null,
        phone: null,
        roleId: null,
      },
    };
  },
  methods:{
    onSubmit(){
      this.$refs.form.$refs.form.validate((valid) => {
          if (valid) {
            this.addUser()
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      
    },
    addUser(){
      addUser(this.form).then(()=>{
          this.$message.success('新增成功')
          this.onBackUser()
      })
    },
    onBackUser() {
      let path = ``
        path = `/staff`
        // this.resolveRouter(path)
        this.$router.push({path: path})
    },
  }
};
</script>

<style lang="scss" scoped>
.form-box {
  margin-top: 50px;
  overflow: hidden;
  background-color: #fff;
  padding: 20px;
}
</style>